const searchContainer = document.querySelector("#search-container-ab-test");
  const closeButton = document.querySelector("#button-close-searchbar");
  const searchButtons = document.querySelectorAll(".thb-secondary-area-item.thb-quick-search");


  closeButton.addEventListener("click", () => {
    event.stopPropagation();

    if(searchContainer.classList.contains("hidden")) return;
    searchContainer.classList.add("hidden");
  });


  searchContainer.addEventListener("click", () => {
    if(!searchButtons.length === 0) {
      console.error("searchButtons could not be found!");
      return;
    }

    searchButtons[0].click();
  });


  searchButtons.forEach(searchButton => searchButton.addEventListener("click", () => {
    if(!searchContainer.classList.contains("hidden")) return;

    setTimeout(() => {
      searchContainer.classList.remove("hidden");
    }, 600);
  }));

  document.querySelector("#button-close-searchbar")?.addEventListener("click", (event) => {
    const searchbar = document.querySelector("#search-container-ab-test");
    const menuMobile = document.querySelector("#mobile-menu.mobile-menu-drawer");
    if(!searchbar?.classList?.contains("hidden") && menuMobile) {
      menuMobile.style.paddingTop = "4rem";
      return;
    }
    if(menuMobile) {
			menuMobile.style.paddingTop = "0";
		}
  });
   
  document.querySelector(".thb-secondary-area-item.thb-quick-search")?.addEventListener("click", (event) => {
      const menuMobile = document.querySelector("#mobile-menu.mobile-menu-drawer");
      
      if(menuMobile) {
        menuMobile.style.paddingTop = "4rem";
      }
  });